// extracted by mini-css-extract-plugin
export default {"UsersInfoPanel":"PaymentCreatePanel_UsersInfoPanel__Z8ilg","buttonsPanel":"PaymentCreatePanel_buttonsPanel__axovl"};